var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullAdvertVkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42ZM22.2833 29.8168C13.1666 29.8168 7.96668 23.5668 7.75001 13.1668H12.3166C12.4666 20.8002 15.8332 24.0334 18.4999 24.7001V13.1668H22.8001V19.7501C25.4334 19.4667 28.1997 16.4668 29.1331 13.1668H33.4332C32.7166 17.2335 29.7165 20.2334 27.5832 21.4668C29.7165 22.4668 33.1334 25.0834 34.4334 29.8168H29.6999C28.6832 26.6501 26.1501 24.2001 22.8001 23.8667V29.8168H22.2833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullAdvertVkIcon);
export default __webpack_public_path__ + "static/media/full-advert-vk-icon.a9d37cd80a0847fbe0c143c61e546ac6.svg";
export { ForwardRef as ReactComponent };